// extracted by mini-css-extract-plugin
export default {"body":"G8c1bfe","bottom":"Gbf2e62","link":"G2788ad"};